import { AxiosError } from "axios";
import { PayloadAction } from "@reduxjs/toolkit";
import { IResponse, ResponseStatus } from "@/types/statusTypes";

interface IResponseExtended extends IResponse {
	isAbortError: boolean;
}

// получение универсальной ошибки
const getResponseError = (action: PayloadAction<unknown>): IResponseExtended => {
	const response: IResponseExtended = { error: ResponseStatus.FAILED, message: "", isAbortError: false }; // default

	// ошибка axios
	if (action.payload instanceof AxiosError) {
		// код ошибки
		if (action.payload.response?.data?.error) response.error = action.payload.response.data.error;
		// сообщение
		if (action.payload.response?.data?.message) {
			response.message = action.payload.response.data.message;
		} else {
			response.message = action.payload.message;
		}
	}
	// обычная ошибка
	else if (action.payload instanceof Error) {
		response.message = action.payload.message;
	}
	// строка
	else if (typeof action.payload === "string") {
		try {
			// пробуем парсить данные на формат IResponse
			const parsedData: unknown = JSON.parse(action.payload);
			if (
				typeof parsedData === "object" &&
				parsedData !== null &&
				"error" in parsedData &&
				"message" in parsedData &&
				typeof parsedData.error === "number" &&
				typeof parsedData.message === "string"
			) {
				response.error = parsedData.error;
				response.message = parsedData.message;
			}
		} catch {
			// при ошибке парсинга передаем строку как есть
			response.message = action.payload;
		}
	}
	// AbortError
	else if (
		"error" in action &&
		typeof action.error === "object" &&
		action.error &&
		"name" in action.error &&
		typeof action.error.name === "string" &&
		action.error.name === "AbortError"
	) {
		response.isAbortError = true;
	}

	return response;
};

export default getResponseError;
